var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 71h48a17 17 0 0 0 0-34 25 25 0 0 0-47-8A21 21 0 0 0 23 71z",
    fill: "#dce8f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 71h48a17 17 0 0 0 0-34 25 25 0 0 0-47-8A21 21 0 0 0 23 71z",
    fill: "none",
    stroke: "#9db5c7",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.22fc037bb38095663c2d342a5ac19d6a.svg";
export { ForwardRef as ReactComponent };